import { Badge, Button, Paragraph, Spacing, Title } from "@sicredi/react";
import styles from "./styles.module.scss";
import { formatValueMoney } from "#/contextProver/ContextProverServices";

interface CarpPlanProps {
  valorBem: number;
  valorParcela: number;
  prazoRestante: number;
  percentualTaxaAdm: number;
  possivelContratar?: boolean;
  melhorProposta?: boolean;
  showButtonDetails?: boolean;
  showButtonSimulate?: boolean;
  showButtonContract?: boolean;
  onClickContratar?: () => void;
  onClickSimular?: () => void;
  onClickDetalhes?: () => void;
}

export const CardPlan = ({
  valorBem,
  valorParcela,
  prazoRestante,
  percentualTaxaAdm,
  possivelContratar = true,
  melhorProposta = false,
  showButtonDetails = false,
  showButtonSimulate = false,
  showButtonContract = false,
  onClickContratar,
  onClickDetalhes,
  onClickSimular,
}: CarpPlanProps) => {
  return (
    <div className={styles.card_container}>
      <div className={styles.card_view}>
        <Title
          className={styles.title}
          size="large"
          weight="semi-bold"
          appearance="primary"
        >
          Plano mensal
        </Title>

        <Paragraph style={{ color: "#33820D" }}>
          {formatValueMoney(valorBem)}
        </Paragraph>

        <Paragraph>Grupo em formação</Paragraph>

        <div className={styles.parcela_prazo}>
          <div style={{ paddingRight: "1rem" }}>
            <Paragraph size="small" weight="light">
              Parcela atual
            </Paragraph>
            <Paragraph weight="bold">
              {formatValueMoney(valorParcela)}
            </Paragraph>
          </div>

          <div style={{ paddingLeft: "1rem" }}>
            <Paragraph size="small" weight="light">
              Prazo
            </Paragraph>
            <Paragraph weight="bold">{prazoRestante} meses</Paragraph>
          </div>
        </div>

        <Paragraph size="small" weight="light">
          Taxa de administração
        </Paragraph>
        <Paragraph weight="bold">
          {Number.parseFloat(String(Number(percentualTaxaAdm))).toFixed(2)}% ao
          mês
        </Paragraph>

        <Spacing appearance="small" />

        {!possivelContratar ? (
          <div style={{ paddingBottom: "16px" }}>
            <Badge
              aria-label="Indisponível para contratação"
              appearance="info"
              data-testid="textIcon"
            >
              Indisponível para contratação
            </Badge>
          </div>
        ) : melhorProposta ? (
          <div style={{ paddingBottom: "16px" }}>
            <Badge
              aria-label="Mais próxima do valor simulado"
              appearance="success"
              data-testid="textIcon"
            >
              Mais próxima do valor simulado
            </Badge>
          </div>
        ) : (
          <div className={styles.badge_empty}></div>
        )}

        {showButtonContract && (
          <Button
            className={styles.button_contratar}
            style={{ display: "flex", flex: 1 }}
            appearance="primary"
            size="small"
            onClick={() => (onClickContratar ? onClickContratar() : undefined)}
          >
            Contratar
          </Button>
        )}
      </div>

      <div
        style={{
          display: "flex",
          width: "100%",
          gap: "0.5rem",
        }}
      >
        {showButtonDetails && (
          <Button
            onClick={() => (onClickDetalhes ? onClickDetalhes() : undefined)}
            appearance="secondary"
            className={styles.button}
          >
            Detalhes
          </Button>
        )}

        {showButtonSimulate && (
          <Button
            onClick={() => (onClickSimular ? onClickSimular() : undefined)}
            appearance="primary"
            className={styles.button}
          >
            Simular
          </Button>
        )}
      </div>
    </div>
  );
};
